import React, { useContext, useState, useEffect } from 'react';
import { BsCheck, BsExclamation } from 'react-icons/bs';
import colors from '../../../assets/styles/colors';
import FormTemplate from '../../../components/FormTemplate';
import { Form, FormFooter, FormRow } from '../../../components/FormTemplate/styles';
import RadioButtonForm from '../../../components/RadioButtonForm';
import InputIntl from '../../../components/InputIntl';
import InputDefault from '../../../components/InputDefault';
import {
  OperationsFormSectionLabel,
  OperationsCheckboxContainer,
  OperationsCheckboxField,
  OperationsCheckboxLabel
} from './styles';
import { internationalOperationsSteps, transationTypes } from '../../../helpers/enum';
import { Controller, useForm } from 'react-hook-form';
import { InternationalOperationsContext } from '../../../store';
import { SecondaryLargeButton } from '../../../components/Buttons/styles';
import { default as InternationalOperationsTypes } from '../../../store/InternationalOperations/types';
import { currencyMoney } from '../../../config/currency';
import { postInternationalOperations } from '../../../services/internationalOperations';
import { useLocation } from 'react-router-dom';
import { postInternationalOperationsExposedPerson } from '../../../services/internationalOperations';
import ModalActionCongratulations from '../../../components/ModalActionCongratulations';
import { useHistory} from 'react-router-dom';
import { 
  PoliticallyExposedPersonLabelForm,
  PoliticallyExposedPersonLineFormItem,
  PoliticallyExposedPersonLineFormHeaderItem,
  PoliticallyExposedPersonLineFormLabel,
  PoliticallyExposedPersonLineFormDeleteItem,
  PoliticallyExposedPersonAddLine,
  Tooltip,
  TooltipTitle,
  TooltipContent,
  InfoCircleImage
} from '../PoliticallyExposedPerson/styles';
import InputDate from '../../../components/InputDate';
import infoCircle from '../../../assets/images/info-circle.svg';
import SearchField from '../../../components/SearchField';
import { parentescoTypes, identificationType } from '../../../helpers/enum';
import { handleChangeIdentification } from '../../../helpers/price';
import { getSolicitationById } from '../../../services/solicitations';
import ModalInfo from '../../../components/ModalInfo';


const Operations = ({ setActiveStep, setLastStep }) => {
  const history = useHistory();
  const location = useLocation();
  const { internationalOperations, setInternationalOperations } = useContext(InternationalOperationsContext);
  const { register, control, errors, handleSubmit, watch, setValue } = useForm({ defaultValues: internationalOperations.operations });
  const [isLoading, setIsLoading] = useState(false);
  const fields = watch();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showModalNullRelative, setShowModalNullRelative] = useState(false);
  const [titleModalNullRelative, setTitleModalNullRelative] = useState('');

  function setMonedaExtranjera(coin) {
    setInternationalOperations({
      type: InternationalOperationsTypes.SET_COIN,
      monedaExtranjera: coin
    })
  }
  function autoCompleteData(){
    if(internationalOperations.operations.banco){
      setValue('banco', internationalOperations.operations.banco);
    }
    if(internationalOperations.operations.numProducto){
      setValue('numProducto', internationalOperations.operations.numProducto);
    }
    if(internationalOperations.operations.moneda){
      setValue('moneda', internationalOperations.operations.moneda);
    }
    if(internationalOperations.operations.tipoProducto){
      setValue('tipoProducto', internationalOperations.operations.tipoProducto);
    }
    if(internationalOperations.operations.pais){
      setValue('pais', internationalOperations.operations.pais);
    }
    if(internationalOperations.operations.ciudad){
      setValue('ciudad', internationalOperations.operations.ciudad);
    }
    if(internationalOperations.operations.montoOperacional){
      setValue('montoOperacional', internationalOperations.operations.montoOperacional);
    }
    if(internationalOperations.operations.montoOperacional){
      setValue('montoOperacional', internationalOperations.operations.montoOperacional);
    }
    if(internationalOperations.operations.cual){
      setValue('cual', internationalOperations.operations.cual);
    }
    setPoliticallyExposedRelatives({ label: 'No', value: false })
    console.log(internationalOperations.relatives)
    let defaultRelatives = [
      {
          "id": 0,
          "nombres": "",
          "apellidos": "",
          "parentesco": "",
          "showParentesco": false,
          "filteredParentescos": []
      }
  ]
  internationalOperations.relatives = defaultRelatives;
    console.log(internationalOperations.relatives)
    /*if(internationalOperations.relatives){
      internationalOperations.relatives.map((item, key) => {
        setValue(`nombres${item.id}`, item.nombre);
        setValue(`apellidos${item.id}`, item.apellidos);
      })
    }*/
  }

  async function initializeStateComponent() {
    try {
      autoCompleteData();
      setIsLoading(false);
    } catch (error) {
      
    }
  }

  useEffect(() =>{
    initializeStateComponent();
  }, [internationalOperations.operations])

  function setMonedaProductsExtranjera(coin) {
    setInternationalOperations({
      type: InternationalOperationsTypes.SET_PRODUCTS_COIN,
      productMonedaExtranjera: coin
    })
  }

  function setTransationType(item) {
    let filteredItem;

    if (internationalOperations.operations.monedaExtranjera.value) {
      if (internationalOperations.operations.transationType.id === item.id) {
        filteredItem = '';
      } else {
        filteredItem = item;
      }
    }

    setInternationalOperations({
      type: InternationalOperationsTypes.SET_TRANSATION_TYPE,
      transationType: filteredItem
    });
  }

  function setPublicStaff(publicStaff) {
    setInternationalOperations({
      type: InternationalOperationsTypes.SET_PUBLIC_STAFF,
      publicStaff
    })
  }

  function setManagePublicResources(managePublicResources) {
    setInternationalOperations({
      type: InternationalOperationsTypes.SET_MANAGE_PUBLIC_RESOURCES,
      managePublicResources
    })
  }

  function setPoliticallyExposed(politicallyExposed) {
    setInternationalOperations({
      type: InternationalOperationsTypes.SET_POLITICALLY_EXPOSED,
      politicallyExposed
    })
  }

  function setPoliticallyExposedRelatives(politicallyExposedRelatives) {
    setInternationalOperations({
      type: InternationalOperationsTypes.SET_POLITICALLY_EXPOSED_RELATIVES,
      politicallyExposedRelatives
    })
  }

  function deleteFieldFromStore(field) {
    let relatives = internationalOperations.relatives;
    relatives = relatives.filter((item) => item.id !== field.id);

    setInternationalOperations({
      type: InternationalOperationsTypes.SET_RELATIVES,
      relatives
    });
  }

  function setIdentificationRadioChecked(radio, name, item) {
    const relatives = internationalOperations.relatives;
    setValue(name, radio.value);
    setValue(`tipoIdentificacion${item.id}`, '');
    item.tipoIdentificacion = radio.value;
    setInternationalOperations({
      type: InternationalOperationsTypes.SET_RELATIVES,
      relatives
    });
  }

  function onChangeIdentification(e, item) {
    let relatives = internationalOperations.relatives;
    var identificacion = undefined;
    if(item.tipoIdentificacion === 'CE') {
      identificacion = e.target.value;
    } else {
      identificacion = handleChangeIdentification(e.target.value);
    }
    item.identificacion = identificacion;
    setValue(`identificacion${item.id}`, identificacion);    
    setInternationalOperations({
      type: InternationalOperationsTypes.SET_RELATIVES,
      relatives,
    });
  } 

  function setSelectedParentesco(parentesco, name) {
    const key = name.replace('parentesco', '');
    setValue(`parentesco${key}`, parentesco.nombre);
    let relatives = internationalOperations.relatives;
    let foundIndex = internationalOperations.relatives.findIndex(x => x.id == key);
    relatives[foundIndex].parentesco = parentesco.id;
    relatives[foundIndex].showParentesco = false;
    setInternationalOperations({
      type: InternationalOperationsTypes.SET_RELATIVES,
      relatives,
    });
  }

  function searchInParentesco(e) {
    try{
      let relatives = internationalOperations.relatives;
      const key = e.target.id.replace('parentesco', '');
      let foundIndex = internationalOperations.relatives.findIndex(x => x.id == key);
      relatives[foundIndex].showParentesco = true;
      let filtered = parentescoTypes.filter(parentesco => parentesco.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1 && !internationalOperations.relatives.map(item => item.parentesco).includes(parentesco.id));
      relatives[foundIndex].filteredParentescos = filtered;

      setInternationalOperations({
        type: InternationalOperationsTypes.SET_RELATIVES,
        relatives,
      });
    } catch (error) {
      console.log(error)
      console.log(error.response)
    }    
  }

  function getIdField(list, max){
    for (var i = 0; i < max; i++) {
      if (!list.includes(i)){
        return i;
      }
    }
    return -1;
  }

  function addRelative() {
    let idx = getIdField(internationalOperations.relatives.map(item => item.id), parentescoTypes.length);
    if(idx > 0) {
      setInternationalOperations({
        type: InternationalOperationsTypes.SET_RELATIVES,
        relatives: [...internationalOperations.relatives, { id: idx, nombres: '', apellidos: '', parentesco: '', tipoIdentificacion: '', identificacion: '', showParentesco: false, filteredParentescos: [] }]
      })
    }
  }

  async function setCompleteStep(dataa) {
    setIsLoading(true);
      let relatives = internationalOperations.relatives;

      if(internationalOperations.politicallyExposedPerson.politicallyExposedRelatives.value){
        for (const familiar of relatives) {
          const { id, tipoIdentificacion, identificacion } = familiar;
  
          if (!tipoIdentificacion || tipoIdentificacion.trim() === "") {
              setTitleModalNullRelative(`El diligenciamiento del dato: tipo de documento es obligatorio en Familiar: #${id+1}`);
              setShowModalNullRelative(true);
              return;
          }
  
          if (!identificacion || identificacion.trim() === "") {
              setTitleModalNullRelative(`El diligenciamiento del dato: número de documento de identidad es obligatorio en Familiar: #${id+1}`);
              setShowModalNullRelative(true);
              return;
          }
      }
      }
      

      relatives = relatives.map(item => {
        return {
          nombres: dataa[`nombres${item.id}`],
          apellidos: dataa[`apellidos${item.id}`],
          parentesco: item.parentesco,
          identificacion:  dataa[`identificacion${item.id}`],
          tipoIdentificacion: item.tipoIdentificacion
        }
      }); 
      await setInternationalOperations({
        type: InternationalOperationsTypes.SET_POLITICALLY_EXPOSED_PERSON,
        politicallyExposedPerson: {
          publicStaff: internationalOperations.politicallyExposedPerson.publicStaff,
          managePublicResources: internationalOperations.politicallyExposedPerson.managePublicResources,
          politicallyExposed: internationalOperations.politicallyExposedPerson.politicallyExposed,
          politicallyExposedRelatives: internationalOperations.politicallyExposedPerson.politicallyExposedRelatives,
          fecha: (internationalOperations.politicallyExposedPerson.politicallyExposed.value || internationalOperations.politicallyExposedPerson.publicStaff.value ||
            internationalOperations.politicallyExposedPerson.managePublicResources.value) ? dataa.fecha : null
        }
      })



      const dataaa = {
        idCredito: location.idCredit,
        funcionarioPublico: internationalOperations.politicallyExposedPerson.publicStaff.value,
        manejoRecursosPublicos: internationalOperations.politicallyExposedPerson.managePublicResources.value,
        expuestoPoliticamente: internationalOperations.politicallyExposedPerson.politicallyExposed.value,
        familiarExpuestoPoliticamente: internationalOperations.politicallyExposedPerson.politicallyExposedRelatives.value,
        fechaVinculacion: (internationalOperations.politicallyExposedPerson.politicallyExposed.value || internationalOperations.politicallyExposedPerson.publicStaff.value ||
          internationalOperations.politicallyExposedPerson.managePublicResources.value) ? dataa.fecha : null,
        familiares: internationalOperations.politicallyExposedPerson.politicallyExposedRelatives.value ? relatives : null
      }
      await postInternationalOperationsExposedPerson(dataaa);
      setIsLoading(false);
      //setShowSuccessModal(true);

    await setInternationalOperations({
      type: InternationalOperationsTypes.SET_OPERATIONS,
      operations: {
        monedaExtranjera: internationalOperations.operations.monedaExtranjera,
        productMonedaExtranjera: internationalOperations.operations.productMonedaExtranjera,
        transationType: internationalOperations.operations.transationType,
        cual: fields.cual,
        banco: fields.banco,
        numProducto: fields.numProducto,
        tipoProducto: fields.tipoProducto,
        pais: fields.pais,
        ciudad: fields.ciudad,
        montoOperacional: fields.montoOperacional,
        moneda: fields.moneda
      }
    });

   
    const data = {
      idCredito: location.idCredit,
      tieneTransaccionExtranjera: internationalOperations.operations.monedaExtranjera.value,
      productoBancario: {
        tieneProducto: internationalOperations.operations.productMonedaExtranjera.value,
        banco: fields.banco,
        pais: fields.pais,
        ciudad: fields.ciudad,
        tipoProducto: fields.tipoProducto,
        numeroProducto: fields.numProducto,
        monto: fields.montoOperacional?.replaceAll('.', ''),
        moneda:  fields.moneda
      },
    }

   
    if (internationalOperations.operations.monedaExtranjera.value) {
      data.transaccionExtranjera = internationalOperations.operations.transationType.id
    }

    if (internationalOperations.operations.transationType?.id === transationTypes[3].id) {
      data.otraCual = internationalOperations.operations.cual
    }
    await postInternationalOperations(data);
    setIsLoading(false);
    history.push({
      pathname: '/admin/document-signing',
      idCredit: location.idCredit
    })
  }

  return (
    <FormTemplate
      idForm="international-operations-step-page"
      activeStep="1/1"
      stepLabel="Operaciones internacionales"
      idCredito={location.idCredit}>
      <Form onSubmit={handleSubmit(setCompleteStep)}>
        <FormRow col="1">
          <RadioButtonForm
            label="Transacciones en moneda extranjera"
            setIdentificationRadioChecked={setMonedaExtranjera}
            selected={internationalOperations.operations.monedaExtranjera.value}
            name="monedaExtranjera"
            id="monedaExtranjera"
            radios={[
              { label: 'Si', value: true },
              { label: 'No', value: false }
            ]} />
        </FormRow>
        {internationalOperations.operations.monedaExtranjera.value && <>
        <OperationsFormSectionLabel>Tipo de transacción</OperationsFormSectionLabel>
        <FormRow col="3">
          {transationTypes.map(item => (
            <OperationsCheckboxContainer>
              <OperationsCheckboxField disabled={!internationalOperations.operations.monedaExtranjera.value} id="checkbox" checked={internationalOperations.operations.transationType?.nombre === item.nombre} onClick={() =>  setTransationType(item)}>
                <BsCheck color={colors.white} id="check-icon" />
              </OperationsCheckboxField>
              <OperationsCheckboxLabel>{item.nombre}</OperationsCheckboxLabel>
            </OperationsCheckboxContainer>
          ))}
        </FormRow>
        <FormRow col="1">
          <Controller
            as={InputDefault}
            control={control}
            label="¿Cuál?"
            name="cual"
            register={register}
            id="cual"
            error={errors.cual}
            value={internationalOperations.operations.cual}
            readOnly={internationalOperations.operations.transationType?.id !== transationTypes[3].id} />
        </FormRow>
        </>}
        <FormRow col="2">
          <RadioButtonForm
            label="Productos bancarios en moneda extranjera"
            setIdentificationRadioChecked={setMonedaProductsExtranjera}
            selected={internationalOperations.operations.productMonedaExtranjera.value}
            name="productMonedaExtranjera"
            id="productMonedaExtranjera"
            radios={[
              { label: 'Si', value: true },
              { label: 'No', value: false }
            ]} />
            {internationalOperations.operations.productMonedaExtranjera.value && 
            <Controller
            as={InputDefault}
            control={control}
            label="Banco"
            name="banco"
            register={register({
              validate: {
                required: value => {
                  if (internationalOperations.operations.productMonedaExtranjera.value == true && (value === '' || value === undefined || value === null)) {
                    return "Este dato es obligatorio";
                  } else {
                    return true;
                  }

                }
              }
            })}
            id="banco"
            error={errors.banco}
            defaultValue={internationalOperations.operations.banco} 
            />
            }
          
        </FormRow>
        {internationalOperations.operations.productMonedaExtranjera.value && <>
          <FormRow col="2">
          <Controller
            type="number"
            as={InputDefault}
            control={control}
            label="Num. Producto"
            name="numProducto"
            placeholder="Digitar valores entre 1 y 9999"
            register={register({
              validate: {
                required: value => {
                  if (internationalOperations.operations.productMonedaExtranjera.value == true && (value === '' || value === undefined || value === null)) {
                    return "Este dato es obligatorio";
                  } else {
                    if (value)
                      return true;
                  }

                }
              }, maxLength: {
                value: 45,
                message: "Exedio la cantidad de números permitidos, digitar 4 números como máximo o valores entre 1 y 9999."
              }
            })}
            id="numProducto"
            error={errors.numProducto}
            defaultValue={internationalOperations.operations.numProducto}
            /*value={internationalOperations.operations.numProducto}*/ />
          <Controller
            as={InputDefault}
            control={control}
            label="Tipo Producto"
            name="tipoProducto"
            register={register({
              validate: {
                required: value => {
                  if (internationalOperations.operations.productMonedaExtranjera.value == true && (value === '' || value === undefined || value === null)) {
                    return "Este dato es obligatorio";
                  } else {
                    return true;
                  }

                }
              }
            })}
            id="tipoProducto"
            error={errors.tipoProducto}
            defaultValue={internationalOperations.operations.tipoProducto}
            /*value={internationalOperations.operations.tipoProducto}*/ />
        </FormRow>
        <FormRow col="2">
          <Controller
            as={InputDefault}
            control={control}
            label="País"
            name="pais"
            register={register({
              validate: {
                required: value => {
                  if (internationalOperations.operations.productMonedaExtranjera.value == true && (value === '' || value === undefined || value === null)) {
                    return "Este dato es obligatorio";
                  } else {
                    return true;
                  }

                }
              }
            })}
            id="pais"
            error={errors.pais}
            value={internationalOperations.operations.pais} />
          <Controller
            as={InputDefault}
            control={control}
            label="Ciudad"
            name="ciudad"
            register={register({
              validate: {
                required: value => {
                  if (internationalOperations.operations.productMonedaExtranjera.value == true && (value === '' || value === undefined || value === null)) {
                    return "Este dato es obligatorio";
                  } else {
                    return true;
                  }

                }
              }


            })}
            id="ciudad"
            error={errors.ciudad}
            defaultValue={internationalOperations.operations.ciudad}
            /*value={internationalOperations.operations.ciudad}*/ />
        </FormRow>
        <FormRow col="2">
          <InputIntl

            id="montoOperacional"
            label="Monto Operacional"
            error={errors.montoOperacional}
            name="montoOperacional"
            defaultValue={internationalOperations.operations.montoOperacional}
            setValue={setValue}
            currencyConfig={currencyMoney}

            register={register({

              validate: {
                required: value => {
                  if (internationalOperations.operations.productMonedaExtranjera.value == true && (value === '' || value === undefined || value === null || value == 0)) {
                    return "Este dato es obligatorio";
                  } else {
                    return true;
                  }

                }
              }, maxLength: {
                value: 4,
                message: "Exedio la cantidad de números permitidos, digitar 4 números como máximo o valores entre 1 y 9999."
              }

            }
            )} />
          <Controller
            as={InputDefault}
            control={control}
            label="moneda"
            name="moneda"
            register={register({
              validate: {
                required: value => {
                  if (internationalOperations.operations.productMonedaExtranjera.value == true && (value === '' || value === undefined || value === null)) {
                    return "Este dato es obligatorio";
                  } else {
                    return true;
                  }

                }
              }, maxLength: {
                value: 3,
                message: "Exedio la cantidad de caracteres permitidos, digitar 3 caracteres como máximo o código ISO. ej USD, EUR, BRZ."
              }
            })}
            id="moneda"
            error={errors.moneda}
            value={internationalOperations.operations.moneda} />
        </FormRow>
        </>}
        <FormRow col="2">
          <RadioButtonForm
            label="Funcionario público"
            setIdentificationRadioChecked={setPublicStaff}
            selected={internationalOperations.politicallyExposedPerson.publicStaff.value}
            name="publicStaff"
            id="publicStaff"
            radios={[
              { label: 'Si', value: true },
              { label: 'No', value: false }
            ]} />
          <RadioButtonForm
            label="Maneja recursos públicos a su cargo"
            setIdentificationRadioChecked={setManagePublicResources}
            selected={internationalOperations.politicallyExposedPerson.managePublicResources.value}
            name="managePublicResources"
            id="managePublicResources"
            radios={[
              { label: 'Si', value: true },
              { label: 'No', value: false }
            ]} />
        </FormRow>
        <FormRow col="2">
          <RadioButtonForm
            label="¿Es o ha sido una persona expuesta políticamente?"
            setIdentificationRadioChecked={setPoliticallyExposed}
            selected={internationalOperations.politicallyExposedPerson.politicallyExposed.value}
            name="politicallyExposed"
            id="politicallyExposed"
            radios={[
              { label: 'Si', value: true },
              { label: 'No', value: false }
            ]} />
        </FormRow>
        <PoliticallyExposedPersonLabelForm>En caso de ser afirmativo, indique la fecha de vinculación y/o desvinculación del cargo</PoliticallyExposedPersonLabelForm>
        <FormRow col="2">
          <InputDate
            aria-required
            type="date"
            label="Fecha"
            name="fecha"
            register={register({ 
              validate: (internationalOperations.politicallyExposedPerson.politicallyExposed.value || internationalOperations.politicallyExposedPerson.publicStaff.value ||
                internationalOperations.politicallyExposedPerson.managePublicResources.value) ? {
                notnull: value => (value != null) || 'Este campo es obligatorio',
                validDate: value => (new Date(value)< Date.now()) || 'La fecha debe ser anterior al presente'
              } : {notExposed:  value => true}
            })}
            id="fecha"
            error={errors.fecha}
            onBlur={() => {}} />
        </FormRow>
        <FormRow col="2">
          <RadioButtonForm
            label={
              <>
                ¿ALGUNO DE SUS FAMILIARES* O ASOCIADOS CERCANOS TIENEN LA CALIDAD DE PERSONA EXPUESTA POLÍTICAMENTE?
                <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-pep'/>
              </>
            }
            setIdentificationRadioChecked={setPoliticallyExposedRelatives}
            selected={internationalOperations.politicallyExposedPerson.politicallyExposedRelatives.value}
            name="politicallyExposedRelatives"
            id="politicallyExposedRelatives"
            radios={[
              { label: 'Si', value: true },
              { label: 'No', value: false }
            ]} />
        </FormRow>
        {internationalOperations.politicallyExposedPerson.politicallyExposedRelatives.value && 
          <>
          {internationalOperations.relatives.map(((item, key) => (
            <PoliticallyExposedPersonLineFormItem key={item.id}>
              <PoliticallyExposedPersonLineFormHeaderItem>
                <PoliticallyExposedPersonLineFormLabel>Familiar {item.id + 1} </PoliticallyExposedPersonLineFormLabel>
                {key > 0 && (
                  <PoliticallyExposedPersonLineFormDeleteItem onClick={() => deleteFieldFromStore(item)}>Eliminar Valor</PoliticallyExposedPersonLineFormDeleteItem>
                )}
              </PoliticallyExposedPersonLineFormHeaderItem>
              <FormRow col="2">
                <SearchField
                  label="Parentesco"
                  name={`parentesco${item.id}`}
                  id={`parentesco${item.id}`}
                  show={item.showParentesco}
                  list={item.filteredParentescos}
                  defaultValue={item.parentesco}
                  selectField={setSelectedParentesco}
                  searchInList={searchInParentesco}
                  register={register({ required: "Este dato es obligatorio" })}
                  placeholder="Buscar..."
                  error={errors[`parentesco${item.id}`]} 
                  disabled={item.parentesco} />
                <Controller
                  as={InputDefault}
                  control={control}
                  error={errors[`nombres${item.id}`]}
                  label="Nombres"
                  name={`nombres${item.id}`}
                  id={`nombres${item.id}`}
                  value={item.nombres}
                  register={register({ required: "Este dato es obligatorio" })} />
              </FormRow>
              <FormRow col="2">
                <Controller
                  as={InputDefault}
                  control={control}
                  error={errors[`apellidos${item.id}`]}
                  label="Apellidos"
                  name={`apellidos${item.id}`}
                  id={`apellidos${item.id}`}
                  value={item.apellidos}
                  register={register({ required: "Este dato es obligatorio" })} />
              </FormRow>
              <FormRow col="2">
                <RadioButtonForm
                  label="Tipo de documento"
                  setIdentificationRadioChecked={(radio, name) => setIdentificationRadioChecked(radio, name, item)}
                  defaultValue="CC"
                  error={errors[`tipoIdentificacion${item.id}`]}
                  selected={item.tipoIdentificacion}
                  name={`tipoIdentificacion${item.id}`}
                  id={`tipoIdentificacion${item.id}`}
                  radios={[
                    { label: 'CC', value: 'CC' },
                    { label: 'CE', value: 'CE' }
                  ]} 
                  />
                <Controller
                  name={`identificacion${item.id}`}
                  control={control}
                  value={item.identificacion}
                  render={() => (
                    <InputDefault                    
                      name={`identificacion${item.id}`}
                      label={"Número de documento de identidad"}
                      register={register({ 
                        pattern: {
                          value: /^\d+(\.\d+)*$/,
                          message: "Error en el número, ingresa uno válido",
                        }
                      })}
                      id={`identificacion${item.id}`}
                      error={errors[`identificacion${item.id}`]}
                      maxLength={item.tipoIdentificacion === 'CE' ? identificationType.ce.max : identificationType.cc.max}
                      minLength={item.tipoIdentificacion === 'CE' ? identificationType.ce.min : identificationType.ce.min}
                      onChange={(e) => onChangeIdentification(e, item)}
                    />
                  )}
                />
                </FormRow>
            </PoliticallyExposedPersonLineFormItem>
          )))}
          <PoliticallyExposedPersonAddLine type="button" onClick={() => addRelative()}>+ Agregar familiar</PoliticallyExposedPersonAddLine>
          </>
        }
        <FormFooter justify="flex-end">
          <SecondaryLargeButton type="submit">Siguiente</SecondaryLargeButton>
        </FormFooter>
      </Form>
      <ModalActionCongratulations
        open={showSuccessModal}
        setShowModal={setShowSuccessModal}
        actionFunctionUpButton={() => history.push({
          pathname: '/admin/document-signing',
          idCredit: location.idCredit
        })}
        title="¡Felicitaciones"
        description="La información del cliente ha sido registrada exitosamente, continúa con el proceso de crédito. En el siguiente paso hay unos documentos que el cliente debe descargar y firmar, para que luego la subas por medio de esta plataforma."
        actionLabelFunctionUpButton="Continuar"
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsCheck size={32} color={colors.white} />} />
        <ModalInfo
        open={showModalNullRelative}
        setShowModal={setShowModalNullRelative}
        title={titleModalNullRelative}
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
        
    </FormTemplate>
  )
}

export default Operations;
